import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useChatRoomConfigStore } from "@/store/useChatRoomConfigStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { pusherService } from "@/di/pusher";
import { syncSession } from "@/di/useCases";
import ChatRoom from "@/views/Chat/ChatRoom/ChatRoom.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatRoomModal',
  setup(__props) {

const store = useChatRoomConfigStore();
const userName = computed(() => store.config?.user_name);
const chatId = computed(() => store.config?.id);
const chatDate = computed(() => store.config?.date);

async function updateScreen() {
  const id = chatId.value;
  const date = chatDate.value;

  store.clear();
  await syncSession.execute();

  if (id && date) {
    pusherService.unsubscribe(`appointment_chat.${id}`, "new-message");
  }

  EventBus.$emit(EventBusNames.UPDATE_CHATS);
}

return (_ctx: any,_cache: any) => {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    id: "chat_room",
    title: userName.value,
    fullHeight: true,
    onModalClosed: updateScreen
  }, {
    content: _withCtx(() => [
      _createVNode(ChatRoom, { type: "modal" })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})